import "./index.css";

export default function RadioButton({ option, checked, onChange }) {
  return (
    <label
      style={{
        color: "#3E3837",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
      }}
      onClick={onChange}
    >
      <input type="radio" checked={checked} onClick={onChange} />
      <span className="custom-radio"></span> {option}
    </label>
  );
}
